import {
  DELETE_PROJECT_INVOICE_REQUEST,
  DELETE_PROJECT_INVOICE_ERROR,
  DELETE_PROJECT_INVOICE_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITY_REQUEST = DELETE_PROJECT_INVOICE_REQUEST;
  context.DELETE_ENTITY_ERROR = DELETE_PROJECT_INVOICE_ERROR;
  context.DELETE_ENTITY_SUCCESS = DELETE_PROJECT_INVOICE_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "projectInvoice";
  context.entityLocation = RESOURCES.ProjectInvoices;

  return context.execute(context)(entity)(state, action);
};

